import React, { Fragment } from 'react'
import styled from 'styled-components'
import Head from 'next/head'
import Layout from '../../components/Layout'
import CategoryContainerList from '../../components/CategoryContainerList/CategoryContainerList'
import { SCREEN_SIZE } from '../../lib/Media'
import Link from 'next/link'
import Text from '../../components/Text/Text'
import { getIosSmartBannerContent } from '../../utils/getIosSmartBannerContent'
import { getCtaLocationMeta } from '../../lib/utils'
import { AMP_EVENT_NAME, getPageTypeByUrl } from '../../lib/amplitude'
import { EventTrackingConsumer } from '../../components/EventTrackingProvider/EventTrackingProvider'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'
import { SPLIT_FEATURES } from '../../utils/constants'
import { getConfigFor } from '../../utils/configService'

const ChangeButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;

  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 2rem;
  }

  ${SCREEN_SIZE.From.Desktop} {
    margin-bottom: 1rem;
    padding: 0 1rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding: 0;
  }
`
const ButtonHeading = styled.div`
  letter-spacing: 1px;
  color: #696969;
`

const Buttons = styled.div`
  display: flex;
  margin-top: 0.5rem;
`
const CategoryButton = styled.div`
  height: 2.25rem;
  line-height: 2rem;
  padding: 0 1rem;
  color: #fff;
  margin-right: 0.5rem;
  border-radius: 0.25rem;
  cursor: pointer;
  background-color: #1557bf;
`
const BrandButton = styled.div`
  height: 2.25rem;
  line-height: 2rem;
  padding: 0 1rem;
  color: #1557bf;
  border-radius: 0.25rem;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #eaeaea;
`

class CategoriesWrp extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelectSubCategory = this.handleSelectSubCategory.bind(this)
    this.handleCategoryClick = this.handleCategoryClick.bind(this)
  }

  handleSelectSubCategory(category) {
    this.setState({ selectedSubCategory: category })
  }

  handleBrandClick = () => {
    const { isEnabled, configuration } =
      getConfigFor(SPLIT_FEATURES.FE_SEGMENT_BRAND_MAIN_CLICKED) || {}
    const isSegmentEvent = isEnabled && configuration?.is_segment_on
    this.props.track({
      [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.BRAND_MAIN_CLICKED,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.IS_SEGEMENT_EVENT]: isSegmentEvent,
    })
  }

  handleCategoryClick() {
    const { isEnabled, configuration } =
      getConfigFor(SPLIT_FEATURES.FE_SEGMENT_CATEGORY_MAIN_CLICKED) || {}
    const isSegmentEvent = isEnabled && configuration?.is_segment_on

    const segProps = {
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: ['browse by category'],
      [GEV.AMPLITUDE_CTA_SUBLOCATION_SECTION_TYPE]: ['navigation'],
    }

    this.props.track({
      [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.CATEGORY_MAIN_CLICKED,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.IS_SEGEMENT_EVENT]: isSegmentEvent,
      ...(isSegmentEvent && segProps),
    })
  }

  render() {
    const { organizationData, categoryList, iosSmartBannerContent } = this.props
    return (
      <Fragment>
        <Head>
          <title>Categories | Everyday Great Value | NTUC FairPrice</title>
          <meta
            name="description"
            key="meta_description"
            content="Browse a range of categories at NTUC FairPrice! FairPrice offers a wide range of products with prices matched online and in stores."
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="Categories | Everyday Great Value | NTUC FairPrice"
          />
          <meta property="og:site_name" content="FairPrice" />
          <meta name="apple-itunes-app" content={iosSmartBannerContent} />
        </Head>
        <Layout organizationData={organizationData} categoryList={categoryList}>
          <ChangeButton>
            <ButtonHeading>
              <Text size="small">BROWSE BY</Text>
            </ButtonHeading>
            <Buttons>
              <CategoryButton onClick={this.handleCategoryClick}>
                <Text size="medium" weight="bold">
                  Category
                </Text>
              </CategoryButton>
              <Link href="/brands" legacyBehavior>
                <BrandButton onClick={this.handleBrandClick}>
                  <Text size="medium">Brand</Text>
                </BrandButton>
              </Link>
            </Buttons>
          </ChangeButton>
          <CategoryContainerList
            onClick={this.handleSelectSubCategory}
            data={categoryList}
          />
        </Layout>
      </Fragment>
    )
  }
}

const Categories = props => (
  <EventTrackingConsumer>
    {({ track }) => <CategoriesWrp {...props} track={track} />}
  </EventTrackingConsumer>
)

Categories.getInitialProps = ctx => {
  const iosSmartBannerContent = getIosSmartBannerContent(ctx)
  return { iosSmartBannerContent }
}

export default Categories
